import type { Task } from './database.types';
import type { ToastKind } from './toast';

interface ToastInput {
  kind: ToastKind;
  title: string;
  body?: string;
  ttlMs?: number;
}

interface UpdateTaskWithRollbackOptions {
  task: Task;
  patch: Partial<Task>;
  patchTaskLocal: (id: string, patch: Partial<Task>) => void;
  push: (toast: ToastInput) => void;
  persist: () => Promise<{ data: Task | null; error: { message: string } | null }>;
  successToast?: ToastInput;
  errorTitle?: string;
}

export async function updateTaskWithRollback({
  task,
  patch,
  patchTaskLocal,
  push,
  persist,
  successToast,
  errorTitle = 'Task update failed',
}: UpdateTaskWithRollbackOptions): Promise<boolean> {
  patchTaskLocal(task.id, patch);

  const { data, error } = await persist();

  if (error) {
    patchTaskLocal(task.id, task);
    push({
      kind: 'error',
      title: errorTitle,
      body: error.message,
      ttlMs: 5000,
    });
    return false;
  }

  if (data) patchTaskLocal(task.id, data as Task);
  if (successToast) push(successToast);
  return true;
}
